export const vttToPlainText = (vtt: string): string => {
  return vtt
    .replace(/\r/g, '')
    .split('\n')
    .filter((line) => {
      const trimmed = line.trim();
      if (!trimmed) return false; // blank
      if (/^WEBVTT/i.test(trimmed)) return false; // header
      if (/^\d+$/.test(trimmed)) return false; // cue index
      if (/\d{2}:\d{2}:\d{2}\.\d{3}\s-->\s/.test(line)) return false; // timestamps
      return true;
    })
    .join(' ')
    .replace(/\s+/g, ' ')
    .trim();
};

export const fetchTranscriptPlainText = async (url: string, init?: RequestInit): Promise<string | null> => {
  const response = await fetch(url, init ?? { cache: 'force-cache' });
  if (!response.ok) {
    return null;
  }

  const vtt = await response.text();
  const text = vttToPlainText(vtt);

  return text || null;
};

